module.exports = __webpack_public_path__ + "img/inventario-banner.2135dc87.png";